import type { UseCustomerBiometryData } from '~/store-v2/contract-formalization/useCustomerBiometry'
import { computed, type Ref } from 'vue'

interface FormalizationStatusReasonAlert {
  feedback: 'error' | 'warning'
  title: string
  description: string
}

function normalizeFormalizationStatus(status?: string | null): string {
  return (status ?? '').trim().toLowerCase()
}

export function useFormalizationStatusReasonAlert(
  biometryData: Ref<UseCustomerBiometryData | undefined>,
) {
  const { t } = useI18n()

  const statusReasonAlert = computed<FormalizationStatusReasonAlert | null>(() => {
    const formalization = biometryData.value
    if (!formalization)
      return null

    const description = formalization.status_reason?.description?.trim()
    if (!description)
      return null

    const status = normalizeFormalizationStatus(formalization.status)

    if (status === 'reproved') {
      return {
        feedback: 'error',
        title: t('customer.biometry.alert.status_reason.reproved.title'),
        description,
      }
    }

    if (status === 'cancelled' || status === 'canceled') {
      return {
        feedback: 'error',
        title: t('customer.biometry.alert.status_reason.cancelled.title'),
        description,
      }
    }

    if (status === 'blocklist_pending') {
      return {
        feedback: 'warning',
        title: t('customer.biometry.alert.status_reason.blocklist_pending.title'),
        description,
      }
    }

    return null
  })

  return {
    statusReasonAlert,
  }
}
